import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Técnico Profissional',
      to: '/empreendimentos/tecnico_profissional',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Técnico Profissional"
    >
      {children}
    </Content>
  );
}

export default BasicContent;
